/* istanbul ignore file */
/**
 * Created by rathompson on 12/17/21
 * File: ViewReducer.actions.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// Action Types
export const CURRENT_VIEWING = 'CURRENT_VIEWING'
export const IS_GLOBAL_MODULE_OPEN = 'IS_GLOBAL_MODULE_OPEN'
export const TENANT_SWITCHER_LOADING = 'TENANT_SWITCHER_LOADING'
export const IS_TENANT_MGM_LOADING = 'IS_TENANT_MGM_LOADING'
export const SHOW_ACTION_STATUS = 'SHOW_ACTION_STATUS'
export const SET_SIDECAR_OPTIONS = 'SET_SIDECAR_OPTIONS'
export const SET_IS_MULTI_TSG = 'SET_IS_MULTI_TSG'

export const setTenantSwitcherLoading = (isTenantSwitcherLoading) => ({
  type: TENANT_SWITCHER_LOADING,
  isTenantSwitcherLoading
})

export const setIsTenantMGMLoading = (isTenantMgmLoading) => ({
  type: IS_TENANT_MGM_LOADING,
  isTenantMgmLoading
})

export const setShowActionStatus = (showActionStatus) => ({
  type: SHOW_ACTION_STATUS,
  showActionStatus
})

export const setSidecarOptions = (isOpen = false, title = '', body = null, extra = {}) => ({
  type: SET_SIDECAR_OPTIONS,
  sidecar: {
    isOpen,
    title,
    body,
    extra
  }
})
